import { memo, Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'

import { formatDate } from 'reactUtils/date'
import { formatters } from 'reactUtils/formatters'

import { Icon } from 'lmcv/components/Icon'
import { Actions } from 'lmcv/redux/modules/coupon'
import { ModalCoupon, ModalError, ModalSkeleton } from 'lmcv/components/Modal'
import { useCloseModal } from 'lmcv/hooks/modal'
import { coupon } from 'lmcv/modules/helpers'

function ModalCouponContainer ({ id, category, active }) {
  const dispatch = useDispatch()
  const data = useSelector(state => state.coupon.get)
  const { isRequest } = useSelector(state => state.coupon.active, shallowEqual)

  const { handleOnClose } = useCloseModal()
  const [customProps, setCustomProps] = useState({
    footerText: {
      expire: '',
      remaining: ''
    },
    subtitle: '',
    button: {
      label: '',
      default: 'Ativar',
      active: 'Ativado'
    }
  })

  useEffect(() => {
    dispatch(Actions.get(id, category, active))
  }, [dispatch, id, category, active])

  useEffect(() => {
    if (!data.error && !data.isRequest) {
      const { expire, type, price, isActive, remainingDays } = data.payload

      setCustomProps({
        subtitle: 'Cupom de',
        footerText: {
          expire: (
            <Fragment>
              Válido até <br />
              <strong>{formatDate(expire, 'D [de] MMMM')}</strong>
            </Fragment>
          ),
          remaining: (
            <Fragment>
              <Icon name="clock" />
              {coupon.expire(remainingDays)}
            </Fragment>
          )
        }
      })
    }
  }, [data, data.error, data.isRequest])

  if (data.isRequest) {
    return <ModalSkeleton />
  }

  if (data.error) {
    return (
      <ModalError
        title="Ops, houve algum problema ao trazer as informações do seu cupom."
        message="Tenta novamente, mais tarde.."
        onClose={handleOnClose}
      />
    )
  }

  const {
    thumbnail,
    title,
    rules,
    description,
    link,
    type,
    giftedBy,
    isActive
  } = data.payload

  const modalProps = {
    image: thumbnail,
    title,
    rules,
    description,
    productLink: link,
    category: type,
    giftedBy,
    isActive,
    isLoading: isRequest,
    onClose: handleOnClose,
    onClickButton: e => {
      e.preventDefault()

      if (!isActive) {
        dispatch(Actions.active(id, type, isActive))
      }

      return null
    },

    ...customProps
  }

  return <ModalCoupon {...modalProps} />
}

export default memo(ModalCouponContainer)
